import {
  FilterRoute,
  ListFilterKey,
  ListFilterOption,
} from '@zonofi/zono-money-store';
// import { PromotionTypes } from '../../constants';

export const DEFINED_FILTERS: Partial<
  Record<FilterRoute, Partial<Record<ListFilterKey, ListFilterOption>>>
> = {
  [FilterRoute.Product]: {
    // [ListFilterKey.Schemes]: {
    //   multiSelect: false,
    //   values: [
    //     {
    //       id: PromotionTypes.PRODUCT_DISCOUNT,
    //       label: 'Discount',
    //       isDefault: false,
    //       selected: false,
    //     },
    //     {
    //       id: PromotionTypes.BUYXGETY,
    //       label: 'Free Product',
    //       isDefault: false,
    //       selected: false,
    //     },
    //   ],
    // },
  },
};

export const SEARCH_ENABLED_ROUTES: Record<FilterRoute, boolean> = {
  [FilterRoute.Customer]: true,
  [FilterRoute.Order]: true,
  [FilterRoute.Product]: false,
  [FilterRoute.Pricing]: false,
  [FilterRoute.Payment]: true,
  [FilterRoute.Invoice]: false,
  [FilterRoute.Conversation]: false,
  [FilterRoute.Ledger]: false,
  [FilterRoute.Dispatch]: false,
  [FilterRoute.Route]: false,
  [FilterRoute.Turnover]: false,
  [FilterRoute.CustomerOrder]: false,
  [FilterRoute.CustomerPayment]: false,
  [FilterRoute.CustomerInvoice]: false,
  [FilterRoute.CustomerDispatch]: false,
  [FilterRoute.SemanticQuery]: false,
};

export const RELATIVE_TIME_RANGE_ROUTES: FilterRoute[] = [
  FilterRoute.SemanticQuery,
];
